<!-- Mobile backdrop overlay -->
<div
  *ngIf="isMobile && mobileOpen"
  class="fixed inset-x-0 bottom-0 bg-black/50 z-40 transition-opacity duration-300"
  [style.top]="isMobile ? 'var(--app-header-height, 0px)' : null"
  (click)="closeMobileDrawer()"
></div>

<!-- Side navigation -->
<div
  class="flex flex-col bg-white h-full px-0 pt-6"
  [ngClass]="{
    'fixed left-0 z-50 w-[280px] shadow-2xl transition-transform duration-300': isMobile,
    'translate-x-0': isMobile && mobileOpen,
    '-translate-x-full': isMobile && !mobileOpen,
    'static': !isMobile
  }"
  [style.top]="isMobile ? 'var(--app-header-height, 0px)' : null"
  [style.height]="isMobile ? 'calc(100dvh - var(--app-header-height, 0px))' : null"
  id="sidenav"
>

  <sigecom-marquee *ngIf="enable"/>

  <!-- Mobile close button -->
  <div *ngIf="isMobile" class="flex justify-end px-4 mb-2">
    <fa-icon
      icon="xmark"
      class="text-xl text-sigecom-gray cursor-pointer"
      (click)="closeMobileDrawer()"
    ></fa-icon>
  </div>

  <div *ngIf="!hideSideNav || isMobile" class="w-full flex justify-center mt-4 mb-10"
    
  >
    <img (click)="redirectTo();" class="cursor-pointer" src="assets/logo/LogoCBDEDark.png"
      alt="Imagem da Confederação Brasileira de Desporto Escolar" width="135" height="60">
  </div>

  <ul class="flex-1 flex flex-col overflow-y-auto" id="style1">

    <li class="text-sigecom-gray font-bold uppercase text-sm cursor-pointer" *ngFor="let menuItem of menuItens">

      <!-- Menu item -->
      <a title="{{menuItem.title}}"
        class="overflow-hidden w-full flex items-center gap-2 px-4 py-2"
        [ngClass]="{
          'justify-between': !hideSideNav || isMobile,
          'justify-center': hideSideNav && !isMobile,
          'text-cbde-dark-blue pl-8 transition-all duration-200 ease-in-out': menuItem.isOpen()
        }"
        (click)="activeMenu(menuItem)">

        <div class="flex items-center gap-2" *ngIf="!hideSideNav || isMobile">
          <fa-icon  [icon]="menuItem.isOpen() ? 'chevron-down' : 'chevron-right'"
            *ngIf="menuItem.subitens.length && (!hideSideNav || isMobile)"></fa-icon>
          <span *ngIf="!hideSideNav || isMobile">{{menuItem.title}}</span>
        </div>

        <fa-icon class="text-lg" [icon]="menuItem.icon"></fa-icon>
      </a>

      <!-- Menu subitems -->
      <ul [@OpenMenu]="'flyIn'"  *ngIf="menuItem.isOpen()">
        <li *ngFor="let subitem of menuItem.subitens">

          <a
            title="{{subitem.title}}"
            class="overflow-hidden w-full px-4 py-2.5 flex items-center gap-2 text-x"
            [ngClass]="{
              'justify-between pl-9': !hideSideNav || isMobile,
              'justify-center': hideSideNav && !isMobile
            }"
            (click)="activeMenu(subitem)"
            [routerLink]="subitem.route"
            routerLinkActive="bg-gray-200"
            [routerLinkActiveOptions]="{exact: true}"
          >

            <div class="flex items-center gap-2" *ngIf="!hideSideNav || isMobile">
              <!-- <fa-icon [icon]="'arrow-right'"></fa-icon> -->
              <span>{{subitem.title}}</span>
            </div>

            <fa-icon class ="text-lg" [icon]="subitem.icon"></fa-icon>
          </a>

        </li>
      </ul>

    </li>
  </ul>

  <!-- Mobile Perfil & Sair buttons -->
  <div *ngIf="isMobile" class="flex flex-col gap-2 px-4 py-3 border-t border-gray-200">
    <a
      class="bg-gray-100 hover:bg-gray-200 cursor-pointer py-2 px-4 rounded flex items-center gap-2 text-sigecom-gray font-medium text-sm transition-colors"
      (click)="profile()"
    >
      <fa-icon icon="circle-user" class="text-sigecom-gray text-lg"></fa-icon>
      <span>Perfil</span>
    </a>
    <a
      class="bg-gray-100 hover:bg-gray-200 cursor-pointer py-2 px-4 rounded flex items-center gap-2 text-sigecom-gray font-medium text-sm transition-colors"
      (click)="logout()"
    >
      <fa-icon icon="right-from-bracket" class="text-sigecom-gray text-lg"></fa-icon>
      <span>Sair</span>
    </a>
  </div>

  <div class="text-center p-2">
    <small>v{{ environment.versionNumber }} {{ environment.versionTag }}</small>
  </div>
</div>
